import { useEffect, useState } from 'react';
import { fromJS } from 'immutable';

import { IBookingEventImt } from '../../interfaces';
import Services from 'services/network';
import { snackbar } from 'common/utils/snackbarUtils';

interface IEventsDetailsResult {
  eventDetails: IBookingEventImt | null;
  isLoading: boolean;
}

export function useEventDetailsQuery(
  corpId: string,
  event: {
    id: string;
    time: string;
  } | null,
): IEventsDetailsResult {
  const [eventDetails, setEventDetails] = useState<IBookingEventImt | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    if (!event) {
      setEventDetails(null);
    } else {
      setIsLoading(true);
      Services.Booking.getSharingEventByIdAndTime(corpId, event.id, event.time)
        .then(result => setEventDetails(fromJS(result)))
        .catch(error => snackbar.error(error.message))
        .finally(() => setIsLoading(false));
    }
  }, [corpId, event]);

  return {
    isLoading,
    eventDetails,
  };
}
